import { render, staticRenderFns } from "./FeaturedArticle.vue?vue&type=template&id=3804950e&"
import script from "./FeaturedArticle.vue?vue&type=script&lang=js&"
export * from "./FeaturedArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports